module.exports = __webpack_public_path__ + "media/images/index/area/faeture_chugoku-5631b4ed8c4a9a8bd851e90772e73b3d.png";